export const enum MESSAGES {
  PRODUCT_ENQUIRY = "We’re really sorry but this item cannot be ordered on the website today. However, give us a call and we can discuss how we can get this or something very similar for you as quick as possible.",
}
